import { render, staticRenderFns } from "./DBuilderCategoryPopup.vue?vue&type=template&id=e5bee47e&scoped=true&"
import script from "./DBuilderCategoryPopup.vue?vue&type=script&lang=js&"
export * from "./DBuilderCategoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./DBuilderCategoryPopup.vue?vue&type=style&index=0&id=e5bee47e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bee47e",
  null
  
)

export default component.exports